// Cents-first money entry: the digits typed ARE the amount in cents, so the decimal sits two
// places from the right and the field reformats every keystroke. Cap 10 digits, DECIMAL(10,2).
const MAX_DIGITS = 10;

// Stripping leading zeros before padding is what lets backspace empty the field: "0.01"
// backspaced to "0.0" yields no significant digits, so it returns "" instead of sticking.
export const formatCents = (raw: string): string => {
    const digits = raw.replace(/\D/g, '').replace(/^0+/, '').slice(0, MAX_DIGITS);

    if (digits === '') {
        return '';
    }

    const padded = digits.padStart(3, '0');

    return `${padded.slice(0, -2)}.${padded.slice(-2)}`;
};

// Payload coercion. Empty is a legitimate UI state for the Beginning Card Balance on a
// non-Manual site, where the field never renders, but CashOutRequestJSON binds it to a
// non-nullable decimal — "" fails deserialisation and returns 400. formatCents is
// idempotent, so re-running it here is safe.
export const toWireAmount = (value: string): string => formatCents(value) || '0.00';
